import React, { useEffect, useState } from "react";

import Europe from "../../images/countries/Europe.png";
import NorthAmerica from "../../images/countries/North-America.png";
import Africa from "../../images/countries/Africa.png";
import Australia from "../../images/countries/Australia.png";
import SouthAmerica from "../../images/countries/South-America.png";
import Asia from "../../images/countries/Asia.png";
import Antarctica from "../../images/countries/Antarctica.png";

import Addy from "../../data/offices";

import "./Offices.css";
import { CancelOutlined } from "@material-ui/icons";

const Offices = () => {
  const [continent, setContinent] = useState("africa");
  const [showAddress, setShowAddress] = useState(false);

  const handleModal = (location) => {
    setContinent(location);
    setShowAddress(!showAddress);
  };

  useEffect(() => {
    if (showAddress)
      document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    else document.getElementsByTagName("BODY")[0].style.overflow = "auto";
  }, [showAddress]);

  return (
    <>
      <div className="offices container d-flex flex-column align-center">
        <h2 className="font-subhead mt-40">Our Offices</h2>
        <p className="py-20">
          Need to locate us in our offices? We are everywhere Check us in your
          location.
        </p>
        <div className="d-flex flex-wrap justify-center w-100">
          <div
            className="offices__icon d-flex flex-column align-center pt-20 pointer"
            onClick={() => handleModal("europe")}
          >
            <div className="position-relative rounded-50">
              <img className="" src={Europe} alt="" />
            </div>
            <span className="font-heavy">Europe</span>
          </div>
          <div
            className="offices__icon d-flex flex-column align-center pt-20 pointer"
            onClick={() => handleModal("north america")}
          >
            <div className="position-relative rounded-50">
              <img className="" src={NorthAmerica} alt="" />
            </div>
            <span className="font-heavy">North America</span>
          </div>
          <div
            className="offices__icon d-flex flex-column align-center pt-20 pointer"
            onClick={() => handleModal("africa")}
          >
            <div className="position-relative rounded-50">
              <img className="" src={Africa} alt="" />
            </div>
            <span className="font-heavy">Africa</span>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-center w-100 py-40">
          <div
            className="offices__icon d-flex flex-column align-center pt-20 pointer"
            onClick={() => handleModal("australia")}
          >
            <div className="position-relative rounded-50">
              <img className="" src={Australia} alt="" />
            </div>
            <span className="font-heavy">Australia</span>
          </div>
          <div
            className="offices__icon d-flex flex-column align-center pt-20 pointer"
            onClick={() => handleModal("south america")}
          >
            <div className="position-relative rounded-50">
              <img className="" src={SouthAmerica} alt="" />
            </div>
            <span className="font-heavy">South America</span>
          </div>
          <div
            className="offices__icon d-flex flex-column align-center pt-20 pointer"
            onClick={() => handleModal("asia")}
          >
            <div className="position-relative rounded-50">
              <img className="" src={Asia} alt="" />
            </div>
            <span className="font-heavy">Asia</span>
          </div>
          <div
            className="offices__icon d-flex flex-column align-center pt-20 pointer"
            onClick={() => handleModal("antartica")}
          >
            <div className="position-relative rounded-50">
              <img className="" src={Antarctica} alt="" />
            </div>
            <span className="font-heavy">Antarctica</span>
          </div>
        </div>
      </div>
      {showAddress && (
        <div className="office__overlay">
          <div className="office__address">
            <h2
              style={{ color: Addy[continent].color }}
              className="text-center position-relative text-capitalise font-subhead p-5 border-bottom-1"
            >
              {continent}
              <div
                className="position-absolute t-0 r-0 pointer"
                onClick={() => handleModal("")}
              >
                <CancelOutlined fontSize="large" style={{ color: "#000" }} />
              </div>
            </h2>
            <div>
              {Addy[continent].addy.map((addy) => (
                <div>
                  <h4
                    style={{ color: Addy[continent].color }}
                    className="py-10 px-20 font-bigger"
                  >
                    {addy.country}
                  </h4>
                  {addy.address.map((address) => (
                    <address className="pt-10 pb-20 px-20">
                      {address.map((line) => (
                        <>
                          {line}
                          <br />
                        </>
                      ))}
                    </address>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Offices;
